export default __webpack_public_path__ + "static/media/abheadshot.77449b25.jpg";